import React from 'react';
import {routerStore} from './routerStore';

interface Props {
  to: string;
}

export class Redirect extends React.Component<Props> {
  render() {
    return null;
  }

  componentDidMount() {
    const {to} = this.props;
    routerStore.redirectTo(to);
  }
}
